import type { TError, TPostBase, TUpdatePost } from '@onesource/schemas';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';
import { getAvailableTagsBaseQueryKey } from '../tags/get-available-tags';

/**
 * Hook to update a post
 * Only the post author can update their own posts
 *
 * @param postId - Post ID (UUID) to update
 */
export const useUpdatePost = (postId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TPostBase, TError, TUpdatePost>({
    mutationFn: async data => {
      const res = await axios.patch<TPostBase>(`/community-hub/posts/${postId}`, data);
      return res.data;
    },
    onSuccess: updated => {
      // Invalidate all posts queries to refresh the feed
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'posts'] });
      // Edited tags can change which tags are "used", so refresh the filter list.
      queryClient.invalidateQueries({ queryKey: getAvailableTagsBaseQueryKey(updated.spaceId) });
    },
  });
};
